import React from 'react';
import { motion } from 'framer-motion';

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.6 } }
};

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="pt-28 pb-16">
      <div className="container mx-auto px-4">
        <motion.h1 
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary"
        >
          Privacy Policy
        </motion.h1>

        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">Introduction</h2>
            <p className="text-gray-700 mb-4">
              At Skill Point Consultants, we respect your privacy and are committed to protecting your personal data. 
              This privacy policy explains how we collect, use, and safeguard your information when you visit our website
              or use our services.
            </p>
            <p className="text-gray-700">
              We may update this policy from time to time to reflect changes in our practices or for other operational, 
              legal, or regulatory reasons. Please check back regularly to stay informed about our privacy practices.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">Information We Collect</h2>
            <p className="text-gray-700 mb-4">
              We may collect personal information that you provide directly to us, such as when you:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Fill out a form on our website</li>
              <li>Apply for a job through our platform</li>
              <li>Subscribe to our newsletter</li>
              <li>Contact us with inquiries or for support</li>
              <li>Register for events or webinars</li>
            </ul>
            <p className="text-gray-700">
              This information may include your name, email address, phone number, resume details, employment history, 
              and any other information you choose to provide.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process job applications and match candidates with potential employers</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Send you technical notices, updates, security alerts, and administrative messages</li>
              <li>Communicate with you about products, services, offers, promotions, and events</li>
              <li>Monitor and analyze trends, usage, and activities in connection with our services</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">Data Security</h2>
            <p className="text-gray-700">
              We implement appropriate security measures to protect your personal information against unauthorized access, 
              alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage 
              is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">Your Rights</h2>
            <p className="text-gray-700 mb-4">
              Depending on your location, you may have certain rights regarding your personal data, including:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Access to your personal data</li>
              <li>Correction of inaccurate or incomplete data</li>
              <li>Deletion of your personal data</li>
              <li>Restriction or objection to processing of your data</li>
              <li>Data portability</li>
            </ul>
            <p className="text-gray-700">
              To exercise these rights, please contact us using the information in the "Contact Us" section below.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4 text-secondary">Contact Us</h2>
            <p className="text-gray-700">
              If you have any questions or concerns about our privacy policy or data practices, please contact us at:{' '}
              <a href="mailto:business@skillpointconsultants.com" className="text-primary hover:underline">
                business@skillpointconsultants.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 